export default __webpack_public_path__ + "static/media/appNotice.604455af.svg";